export const enum EMITTER_NAME {
  SaveComponentsGlobal = 'save-components-global', // 保存数据, 包括普通、表单、大屏, 共用一个 emitter

  ShowSaveDialogForBackHome = 'show-save-dialog-for-back-home', // 点击 '返回首页' 展示是否保存弹窗
  BackHomeOnClickSaveDialog = 'back-home-on-click-save-dialog', // 是否保存弹窗, 保存|不保存都返回首页

  ShowSaveDialogForMenuToDatasource = 'show-save-dialog-for-menu-to-datasource', // 从 '菜单' 切换到 '数据集' 展示是否保存弹窗
  ChangeMenuToDatasourceOnClickSaveDialog = 'change-menu-to-datasource-on-click-save-dialog', // 是否保存弹窗, 保存|不保存都切换到 '数据集'

  ShowComponentAttribute = 'show-component-attribute', // 拖动组件到编辑区, 显示对应的组件属性

  ShowFirstMenu = 'show-first-menu', // 从数据集切换到菜单, 展示第一个菜单页

  OpenProjectConfigDialogForNavbar = 'open-project-config-dialog-for-navbar', // 点击头部导航展示修改项目弹窗(修改缓存列表)

  OpenProjectEditDialogForNavbar = 'open-project-edit-dialog-for-navbar', // 点击头部导航展示修改项目弹窗(修改缓存列表)

  OpenPermissionEditDialogForNavbar = 'open-permission-edit-dialog-for-navbar', // 点击头部导航展示权限编辑弹窗

  AddCustomApiFolder = 'add-custom-api-folder', // API接口 添加文件夹
  AddCustomApiFile = 'add-custom-api-file', // API接口 - 添加API接口
  SaveCustomApi = 'save-custom-api', // API 接口 保存

  ShowApiPrefixDialog = 'show-api-prefix-dialog', // API 前缀配置弹窗

  RefreshApiPrefixOptions = 'refresh-api-prefix-options', // 重新获取接口, 刷新 api 前缀下拉框

  SyncRelatedData = 'sync-related-data', // 同步关联数据

  //  ------------------ 数据源 ------------------
  RefreshExternalDataSourceList = 'RefreshExternalDataSourceList', // 刷新外部数据源列表
  InitExternalDataSourceForm = 'InitExternalDataSourceForm', // 点击外部数据源, 展示当前
  ClickCreateExternalDataSourceButton = 'ClickCreateExternalDataSourceButton', // 新增数据源 '+' 点击
  SaveExternalDataSource = 'SaveExternalDataSource', // 保存外部数据源(根据是否保存弹窗触发)
  SaveExternalDataSourceSucceed = 'SaveExternalDataSourceSucceed', // 保存外部数据源(保存成功)

  RefreshInternalDataSetDataTableTree = 'RefreshInternalDataSetDataTableTree', // 刷新内部数据源-数据集-数据表

  SelectedDataSetItemFromDrawer = 'SelectedDataSetItemFromDrawer', // 数据集/数据表抽屉, 选中某个数据集
  SelectedDataTableItemFromDrawer = 'SelectedDataTableItemFromDrawer', // 数据集/数据表抽屉, 选中某个数据表
  CHANGE_EDIT_PAGE = 'change-dit-page', // 菜单栏点击各页面时使用，目前是为了避免切换页面时，重复请求上个页面得内容

  //  ------------------ 编辑页 ------------------
  BigScreenSelectWidget = 'big-screen-select-widget',
  // 更新页面组件属性
  UpdatePageOptionByNewOption = 'updatePageOptionByNewOption',
  // 刷新页面组件
  ReloadWidget = 'reloadWidget',
  // 编辑重载页面组件
  EditPageReloadWidget = 'editPage-reloadWidget',
  // 复制组件
  EditPageCopy = 'editPage-copy',
  // 粘贴
  EditPagePaste = 'editPage-paste',
  // 更改历史记录
  EditPageHistory = 'editPage-history',
  // 历史记录前进
  EditPageForward = 'editPage-forward',
  // 历史记录后退
  EditPageBackward = 'editPage-backward',
  // 组件锁定
  EditPageWidgetLock = 'editPage-lock',
  // 组件解锁
  EditPageWidgetUnLock = 'editPage-unlock',
  // 组合
  EditPageWidgetCompose = 'editPage-compose',
  // 组合取消
  EditPageWidgetDeCompose = 'editPage-decompose',
  // 缩放变化
  EditPageScale = 'editPage-scale',
  // 删除组件
  RemoveWidget = 'removeWidget',
  // 右键菜单显隐
  EditContentMenuShow = 'editContentMenuShow',
  // 图层发现变化
  EditLayerChange = 'editLayerChange',
  // 排序
  EditPageAlign = 'editPage-align',
  // 面板切换
  EditPagePanelChange = 'editPage-panelChange'
}
